import { ToolDeclaration, tools } from '@worktango/ai-assistant/react';
import { getCurrentUserTool } from './getCurrentUser';
import { getSurveysListTool } from './getSurveysList';
import { createSurveyAggregatedResultsTool } from './getSurveyAggregatedResults';
import { createAction } from './createAction';
import { listRelatedReportingSurveysTool } from './listRelatedReportingSurveys';
import { listRelatedFactorsTool } from './listRelatedFactors';
import { questionCommentsAnalysisTool } from './questionCommentsAnalysis';
import { getHeatmapDataTool } from './getHeatmapData';
import { getBasicSurveyInfoTool } from './getBasicSurveyInfo';
import { surveyCommentAnalysisTool } from './surveyCommentAnalysis';
import { getMyActionsListTool } from './getMyActionsList';

export const createWorkTangoTools = ({ peopleLeaderAttributeId }: { peopleLeaderAttributeId: number | null }) =>
  [
    ...Object.values({
      ...tools.sharedTools,
      getCurrentTimeTool: undefined,
      askSingleShotQuestion: undefined,
      analyzeCurrentPage: undefined,
    }),
    getCurrentUserTool,
    getSurveysListTool,
    createSurveyAggregatedResultsTool({ peopleLeaderAttributeId }),
    createAction,
    listRelatedReportingSurveysTool,
    listRelatedFactorsTool,
    questionCommentsAnalysisTool,
    getHeatmapDataTool,
    getBasicSurveyInfoTool,
    surveyCommentAnalysisTool,
    getMyActionsListTool,
  ].filter((tool) => !!tool);

// Default export for backward compatibility
export const workTangoTools = createWorkTangoTools({ peopleLeaderAttributeId: null });

export const workTangoToolsMap = workTangoTools.reduce(
  (acc, tool) => {
    acc[tool.name] = tool;
    return acc;
  },
  {} as Record<string, ToolDeclaration>,
);
